import React from 'react';
import { ReactComponent as Activity } from './activity.svg';
import { ReactComponent as AlertCircle } from './alert-circle.svg';
import { ReactComponent as CheckCircle } from './check-circle.svg';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as ChevronDown } from './chevron-down.svg';
import { ReactComponent as Mail1 } from './mail-01.svg';
import { ReactComponent as XClose } from './x-close.svg';
import { ReactComponent as File4 } from './file-04.svg';
import { ReactComponent as FilePlus2 } from './file-plus-02.svg';
import { ReactComponent as ArrowNarrowLeft } from './arrow-narrow-left.svg';
import { ReactComponent as InfoCircle } from './info-circle.svg';
import { ReactComponent as UploadCloud2 } from './upload-cloud-02.svg';
import { ReactComponent as Share4 } from './share-04.svg';
import { ReactComponent as Building7 } from './building-07.svg';
import { ReactComponent as Container } from './container.svg';
import { ReactComponent as Package } from './package.svg';
import { ReactComponent as LogOut1 } from './log-out-01.svg';
import { ReactComponent as PlusCircle } from './plus-circle.svg';
import { ReactComponent as InfoHexagon } from './info-hexagon.svg';
import { ReactComponent as MarkerPin1 } from './marker-pin-01.svg';
import { ReactComponent as SearchLg } from './search-lg.svg';
import { ReactComponent as Download1 } from './download-01.svg';
import { ReactComponent as ChevronLeft } from './chevron-left.svg';
import { ReactComponent as ChevronRight } from './chevron-right.svg';
import { ReactComponent as ArrowLeft } from './arrow-left.svg';
import { ReactComponent as ArrowRight } from './arrow-right.svg';
import { ReactComponent as Diamond1 } from './diamond-01.svg';
import { ReactComponent as AnnotiationAlert } from './annotation-alert.svg';
import { ReactComponent as Plus } from './plus.svg';
import { ReactComponent as Filter } from './filter-lines.svg';
import { ReactComponent as Edit2 } from './edit-02.svg';
import { ReactComponent as AlertTriangle } from './alert-triangle.svg';
import { ReactComponent as Upload1 } from './upload-01.svg';
import { ReactComponent as Settings1 } from './settings-01.svg';
import { ReactComponent as UserPlus1 } from './user-plus-01.svg';
import { ReactComponent as Trash1 } from './trash-01.svg';
import { ReactComponent as Camera1 } from './camera-01.svg';
import { ReactComponent as Eye } from './eye.svg';
import { ReactComponent as X } from './x.svg';
import { ReactComponent as DataFlow1 } from './dataflow-01.svg';
import { ReactComponent as DotsVertical } from './dots-vertical.svg';
import { ReactComponent as Wallet1 } from './wallet-01.svg';
import { ReactComponent as Key1 } from './key-01.svg';
import { ReactComponent as RefreshCw5 } from './refresh-cw-05.svg';
import { ReactComponent as TerminalBrowser } from './terminal-browser.svg';
import { ReactComponent as Backpack } from './backpack.svg';
import { ReactComponent as Settings4 } from './settings-04.svg';
import { ReactComponent as Building3 } from './building-03.svg';
import { ReactComponent as Tag1 } from './tag-01.svg';
import { ReactComponent as ShoppingBag1 } from './shopping-bag-01.svg';
import { ReactComponent as BriefCase1 } from './briefcase-01.svg';
import { ReactComponent as SwitchVertical1 } from './switch-vertical-01.svg';
import { ReactComponent as SwitchVertical2 } from './switch-vertical-02.svg';
import { ReactComponent as ArrowDown } from './arrow-down.svg';
import { ReactComponent as ArrowUp } from './arrow-up.svg';
import { ReactComponent as XCircle } from './x-circle.svg';
import { ReactComponent as Truck1 } from './truck-01.svg';
import { ReactComponent as Calendar } from './calendar.svg';
import { ReactComponent as Link } from './link-01.svg';
import { ReactComponent as DataFlow4 } from './dataflow-04.svg';
import { ReactComponent as SearchRefraction } from './search-refraction.svg';
import { ReactComponent as ImagePlus } from './image-plus.svg';
import { ReactComponent as Type01 } from './type-01.svg';
import { ReactComponent as Columns03 } from './columns-03.svg';
import { ReactComponent as TextInput } from './text-input.svg';
import { ReactComponent as Square } from './square.svg';
import { ReactComponent as FileDownload02 } from './file-download-02.svg';
import { ReactComponent as ArrowBlockRight } from './arrow-block-right.svg';
import { ReactComponent as SwitchHorizontal01 } from './switch-horizontal-01.svg';
import { ReactComponent as Copy02 } from './copy-02.svg';

export const ActivityIcon = <Activity />;
export const AlertCircleIcon = <AlertCircle />;
export const CheckCircleIcon = <CheckCircle />;
export const CheckIcon = <Check />;
export const ChevronDownIcon = <ChevronDown />;
export const Mail1Icon = <Mail1 />;
export const XCloseIcon = <XClose />;
export const File4Icon = <File4 />;
export const FilePlus2Icon = <FilePlus2 />;
export const ArrowNarrowLeftIcon = <ArrowNarrowLeft />;
export const InfoCircleIcon = <InfoCircle />;
export const UploadCloud2Icon = <UploadCloud2 />;
export const Share4Icon = <Share4 />;
export const Building7Icon = <Building7 />;
export const ContainerIcon = <Container />;
export const PackageIcon = <Package />;
export const LogOut1Icon = <LogOut1 />;
export const PlusCircleIcon = <PlusCircle />;
export const InfoHexagonIcon = <InfoHexagon />;
export const MarkerPin1Icon = <MarkerPin1 />;
export const SearchLgIcon = <SearchLg />;
export const Download1Icon = <Download1 />;
export const ChevronLeftIcon = <ChevronLeft />;
export const ChevronRightIcon = <ChevronRight />;
export const ArrowLeftIcon = <ArrowLeft />;
export const ArrowRightIcon = <ArrowRight />;
export const Diamond1Icon = <Diamond1 />;
export const AnnotationAlertIcon = <AnnotiationAlert />;
export const PlusIcon = <Plus />;
export const FilterIcon = <Filter />;
export const Edit2Icon = <Edit2 />;
export const AlertTriangleIcon = <AlertTriangle />;
export const Upload1Icon = <Upload1 />;
export const Settings1Icon = <Settings1 />;
export const UserPlus1Icon = <UserPlus1 />;
export const Trash1Icon = <Trash1 />;
export const Camera1Icon = <Camera1 />;
export const EyeIcon = <Eye />;
export const XIcon = <X />;
export const DataFlow1Icon = <DataFlow1 />;
export const DotsVerticalIcon = <DotsVertical />;
export const Wallet1Icon = <Wallet1 />;
export const Key1Icon = <Key1 />;
export const RefreshCw5Icon = <RefreshCw5 />;
export const TerminalBrowserIcon = <TerminalBrowser />;
export const BackpackIcon = <Backpack />;
export const Settings4Icon = <Settings4 />;
export const Building3Icon = <Building3 />;
export const Tag1Icon = <Tag1 />;
export const ShoppingBag1Icon = <ShoppingBag1 />;
export const BriefCase1Icon = <BriefCase1 />;
export const SwitchVertical1Icon = <SwitchVertical1 />;
export const SwitchVertical2Icon = <SwitchVertical2 />;
export const ArrowDownIcon = <ArrowDown />;
export const ArrowUpIcon = <ArrowUp />;
export const XCircleIcon = <XCircle />;
export const Truck1Icon = <Truck1 />;
export const CalendarIcon = <Calendar />;
export const LinkIcon = <Link />;
export const DataFlow4Icon = <DataFlow4 />;
export const SearchRefractionIcon = <SearchRefraction />;
export const ImagePlusIcon = <ImagePlus />;
export const Type01Icon = <Type01 />;
export const Columns03Icon = <Columns03 />;
export const TextInputIcon = <TextInput />;
export const SquareIcon = <Square />;
export const FileDownload02Icon = <FileDownload02 />;
export const ArrowBlockRightIcon = <ArrowBlockRight />;
export const SwitchHorizontal01Icon = <SwitchHorizontal01 />;
export const Copy02Icon = <Copy02 />;
